var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRectangle104A = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 104 60",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M23 6h10l.752 8.274A2.5 2.5 0 0 1 31.262 17h-6.524a2.5 2.5 0 0 1-2.49-2.726L23 6Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#BABCC0",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m22 8 .223-.445A2.813 2.813 0 0 1 24.738 6h6.524c1.065 0 2.039.602 2.515 1.555L34 8"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M81 54H71l-.752-8.274A2.5 2.5 0 0 1 72.738 43h6.525a2.5 2.5 0 0 1 2.49 2.726L81 54Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#BABCC0",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m82 52-.222.445A2.812 2.812 0 0 1 79.262 54H72.74a2.813 2.813 0 0 1-2.516-1.555L70.001 52"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M39 6h10l.752 8.274A2.5 2.5 0 0 1 47.262 17h-6.524a2.5 2.5 0 0 1-2.49-2.726L39 6Z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  stroke: "#BABCC0",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m38 8 .223-.445A2.813 2.813 0 0 1 40.738 6h6.524c1.065 0 2.039.602 2.515 1.555L50 8"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M65 54H55l-.752-8.274A2.5 2.5 0 0 1 56.738 43h6.525a2.5 2.5 0 0 1 2.49 2.726L65 54Z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  stroke: "#BABCC0",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m66 52-.222.445A2.812 2.812 0 0 1 63.262 54H56.74a2.813 2.813 0 0 1-2.516-1.555L54.001 52"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M55 6h10l.752 8.274A2.5 2.5 0 0 1 63.262 17h-6.524a2.5 2.5 0 0 1-2.49-2.726L55 6Z"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  stroke: "#BABCC0",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m54 8 .223-.445A2.813 2.813 0 0 1 56.738 6h6.524c1.065 0 2.039.602 2.515 1.555L66 8"
})), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M49 54H39l-.752-8.274A2.5 2.5 0 0 1 40.738 43h6.525a2.5 2.5 0 0 1 2.49 2.726L49 54Z"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  stroke: "#BABCC0",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m50 52-.222.445A2.812 2.812 0 0 1 47.262 54H40.74a2.813 2.813 0 0 1-2.516-1.555L38.001 52"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M71 6h10l.753 8.274A2.5 2.5 0 0 1 79.263 17h-6.525a2.5 2.5 0 0 1-2.49-2.726L71 6Z"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  stroke: "#BABCC0",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m70 8 .223-.445A2.813 2.813 0 0 1 72.74 6h6.523c1.066 0 2.04.602 2.516 1.555L82 8"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M33 54H23l-.752-8.274A2.5 2.5 0 0 1 24.738 43h6.524a2.5 2.5 0 0 1 2.49 2.726L33 54Z"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  stroke: "#BABCC0",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m34 52-.223.445A2.813 2.813 0 0 1 31.262 54h-6.524a2.813 2.813 0 0 1-2.515-1.555L22 52"
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M98 25v10l-8.273.752A2.5 2.5 0 0 1 87 33.262v-6.524a2.5 2.5 0 0 1 2.727-2.49L98 25Z"
})), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
  stroke: "#BABCC0",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m96 24 .446.223A2.813 2.813 0 0 1 98 26.738v6.524c0 1.065-.602 2.039-1.555 2.515L96 36"
})), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M6 35V25l8.274-.752A2.5 2.5 0 0 1 17 26.738v6.524a2.5 2.5 0 0 1-2.726 2.49L6 35Z"
})), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
  stroke: "#BABCC0",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m8 36-.445-.223A2.813 2.813 0 0 1 6 33.262v-6.524c0-1.065.602-2.039 1.555-2.515L8 24"
})), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M20 22.5a2.5 2.5 0 0 1 2.5-2.5h59a2.5 2.5 0 0 1 2.5 2.5v15a2.5 2.5 0 0 1-2.5 2.5h-59a2.5 2.5 0 0 1-2.5-2.5v-15Z"
})));
SvgRectangle104A.viewBox = '0 0 104 60';
const ForwardRef = /*#__PURE__*/forwardRef(SvgRectangle104A);
export default ForwardRef;